import ProviderLinkActionTypes from "./providerLink.types";

export const setProviderLinkSelectedFilter = (filters) => ({
  type: ProviderLinkActionTypes.SET_PROVIDER_LINK_SELECTED_FILTER,
  payload: filters
});
